var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "18",
        viewBox: "0 0 16 18",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M14 7.66675C14 12.3334 8 16.3334 8 16.3334C8 16.3334 2 12.3334 2 7.66675C2 6.07545 2.63214 4.54933 3.75736 3.42411C4.88258 2.29889 6.4087 1.66675 8 1.66675C9.5913 1.66675 11.1174 2.29889 12.2426 3.42411C13.3679 4.54933 14 6.07545 14 7.66675Z",
          stroke: "black",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M8 9.66675C9.10457 9.66675 10 8.77132 10 7.66675C10 6.56218 9.10457 5.66675 8 5.66675C6.89543 5.66675 6 6.56218 6 7.66675C6 8.77132 6.89543 9.66675 8 9.66675Z",
          stroke: "black",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }